import { useState, useEffect } from "react";
import env from "react-dotenv";
import { ethers } from "ethers";
import { getAccount, watchAccount, readContract, prepareWriteContract, writeContract, fetchBalance } from '@wagmi/core';
import { Network, Alchemy } from 'alchemy-sdk';
import { saleContractAbi } from "./data/sale";

function Sale() {

  const settings = {
    apiKey: !!parseInt(env.DEV) ? "RGC-Zuix7E6ZVcYPjSMRykofOOiFnBYI" : "kzGcC2KpO-8mlNi2W71EQBD8agkThCBY",
    network: !!parseInt(env.DEV) ? Network.MATIC_MUMBAI : Network.MATIC_MAINNET,
  };

  const alchemy = new Alchemy(settings);

  const [account, setAccount] = useState(getAccount());
  const [balance, setBalance] = useState({});

  const [items, setItems] = useState([]);
  const [page, setPage] = useState();
  const [count, setCount] = useState(0);
  const [publicPrice, setPublicPrice] = useState(0);
  const [whiteListPrice, setWhiteListPrice] = useState(0);
  const [whiteListed, setWhiteListed] = useState(true);
  const [locked, setLocked] = useState(true);
  const [loading, setLoading] = useState(true);

  const initData = async () => {
    readContract({
      address: env.SALE_CONTRACT_ADDRESS,
      abi: saleContractAbi,
      functionName: 'locked',
    }).then((res) => {
      setLocked(res);
    });
    readContract({
      address: env.SALE_CONTRACT_ADDRESS,
      abi: saleContractAbi,
      functionName: 'publicPrice',
    }).then((res) => {
      setPublicPrice(res);
    });
    readContract({
      address: env.SALE_CONTRACT_ADDRESS,
      abi: saleContractAbi,
      functionName: 'whiteListPrice',
    }).then((res) => {
      setWhiteListPrice(res);
    });
    fetchBalance({
      address: account.address,
    }).then((res) => {
      setBalance(res);
    });
    readContract({
      address: env.SALE_CONTRACT_ADDRESS,
      abi: saleContractAbi,
      functionName: 'whiteList',
      args: [account.address],
    }).then((res) => {
      setWhiteListed(res);
    });
  };

  const buyItem = async (item) => {
    const config = await prepareWriteContract({
      address: env.SALE_CONTRACT_ADDRESS,
      abi: saleContractAbi,
      functionName: 'buy',
      args: [item.tokenId],
      overrides: {
        from: account.address,
        value: whiteListed ? whiteListPrice : publicPrice,
      },
    });
    writeContract(config).then(() => {
      setPage();
      loadChunk();
    });
  };

  const loadChunk = async () => {
    setLoading(true);
    alchemy.nft.getNftsForOwner("0xD2F431a1284Dd955Ed30356Fb56d92bDe36aA6ab", {
      contractAddresses: [env.SALE_COLLECTION_ADDRESS],
      pageKey: page,
      pageSize: 100,
    }).then((res) => {
      setCount(count + 100);
      setPage(res.pageKey);
      let currentItems = items;
      res.ownedNfts.forEach((nft) => {
        currentItems.push({
          tokenId: nft.tokenId,
        });
      });
      setItems(currentItems);
      setLoading(false)
    });
  };

  const handleScroll = async (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      loadChunk();
    }
  }

  const unwatchAccount = watchAccount((a) => {
    setAccount(a)
    fetchBalance({
      address: a.address,
    }).then((res) => {
      setBalance(res);
    });
    readContract({
      address: env.SALE_CONTRACT_ADDRESS,
      abi: saleContractAbi,
      functionName: 'whiteList',
      args: [a.address],
    }).then((res) => {
      setWhiteListed(res);
    });
  });

  useEffect(() => {
    initData();
    loadChunk();
  }, [])

  return (
    <section id="sale">
      <div className="text-center">
        {account.isConnected && <p>Your balance: {balance?.formatted} {balance?.symbol}</p>}
        {account.isDisconnected && !locked && <p>Connect your wallet to get your favorite Fairy Soup!</p>}
        <h1 className="sale-title">Fairy Soups Sale</h1>
        <div className="sale-subtitle">
          <p>Public price: { ethers.utils.formatEther(publicPrice) } MATIC</p>
          {env.HAS_WL > 0 && <p>WL price: { ethers.utils.formatEther(whiteListPrice) } MATIC</p>}
          {account.isConnected && whiteListed && <p>Congrats! You obtained a WL spot!</p>}
        {account.isConnected && balance?.value && balance.value.lte(whiteListed ? whiteListPrice : publicPrice) && <p><small>Attention: you don't have enogh MATIC to buy a Fairy Soup</small></p>}
        </div>
      </div>
      <div onScroll={handleScroll} style={{overflow: 'hidden scroll', maxHeight: '80vh'}}>
        <div className="row">
          {items.map((item) => {
            const imgUri = "https://moonybel.com/fairy-soups/" + item.tokenId + ".png";
            const openseaUri = "https://opensea.io/assets/matic/" + env.SALE_COLLECTION_ADDRESS + "/" + item.tokenId;
            return (
              <div className="col-sm-6 col-md-4">
                <p className="text-center item-title">Fairy Soup #{ item.tokenId }</p>
                <p>
                  <img src={ imgUri } className="item-image img-fluid img-thumbnail"/>
                </p>
                <div className="item-button-panel">
                  <button className="btn item-button item-button-buy" disabled={account.isDisconnected || locked || (balance?.value && balance.value.lte(whiteListed ? whiteListPrice : publicPrice))} onClick={ () => buyItem(item) }>Buy it!</button>
                  <a className="btn item-button item-button-os" href={ openseaUri } target="_blank">
                    <svg width="22" height="22" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M90 45C 90 69.8514 69.8514 90 45 90C 20.1486 90 0 69.8514 0 45C 0 20.1486 20.1486 0 45 0C 69.8566 0 90 20.1486 90 45z" stroke="none" fill="#FFFFFF" fillRule="nonzero"></path>
                      <path d="M22.2011 46.512L22.3952 46.2069L34.1015 27.8939C 34.2726 27.6257 34.6748 27.6535 34.8043 27.9447C 36.7599 32.3277 38.4475 37.7786 37.6569 41.1721C 37.3194 42.5683 36.3947 44.4593 35.3544 46.2069C 35.2204 46.4612 35.0724 46.7109 34.9152 46.9513C 34.8413 47.0622 34.7164 47.127 34.5823 47.127L34.5823 47.127L22.5432 47.127C 22.2195 47.127 22.03 46.7756 22.2011 46.512z" stroke="none" fill="#2081E2" fillRule="nonzero"></path>
                      <path d="M74.38 49.9149L74.38 52.8137C 74.38 52.9801 74.2783 53.1281 74.1303 53.1928C 73.2242 53.5812 70.1219 55.0052 68.832 56.799C 65.5402 61.3807 63.0251 67.932 57.4031 67.932L57.4031 67.932L33.9489 67.932C 25.6362 67.932 18.9 61.1727 18.9 52.8322L18.9 52.8322L18.9 52.564C 18.9 52.3421 19.0803 52.1618 19.3022 52.1618L19.3022 52.1618L32.377 52.1618C 32.6359 52.1618 32.8255 52.4022 32.8024 52.6565C 32.7099 53.5072 32.8671 54.3764 33.2693 55.167C 34.046 56.7435 35.655 57.7283 37.3933 57.7283L37.3933 57.7283L43.866 57.7283L43.866 52.675L37.4673 52.675C 37.139 52.675 36.9449 52.2959 37.1344 52.0277C 37.2038 51.9214 37.2824 51.8104 37.3656 51.6856C 37.9712 50.8257 38.8358 49.4895 39.6957 47.9684C 40.2829 46.9421 40.8516 45.8463 41.3093 44.746C 41.4018 44.5472 41.4757 44.3438 41.5497 44.1449C 41.6745 43.7936 41.804 43.4653 41.8964 43.1371C 41.9889 42.8597 42.0629 42.5684 42.1369 42.2956C 42.3542 41.3617 42.4466 40.3723 42.4466 39.3459C 42.4466 38.9437 42.4281 38.523 42.3911 38.1207C 42.3727 37.6815 42.3172 37.2423 42.2617 36.8031C 42.2247 36.4147 42.1554 36.031 42.0814 35.6288C 41.9889 35.0416 41.8595 34.4591 41.7115 33.8719L41.7115 33.8719L41.6607 33.65C 41.5497 33.2478 41.4572 32.864 41.3278 32.4618C 40.9625 31.1996 40.5418 29.9698 40.098 28.8186C 39.9362 28.3609 39.7512 27.9217 39.5663 27.4825C 39.2935 26.8213 39.0161 26.2203 38.7618 25.6516C 38.6324 25.3927 38.5214 25.1569 38.4105 24.9165C 38.2856 24.6437 38.1562 24.371 38.0267 24.112C 37.9343 23.9132 37.8279 23.7283 37.7539 23.5434L37.7539 23.5434L36.9634 22.0824C 36.8524 21.8836 37.0373 21.6478 37.2546 21.7079L37.2546 21.7079L42.2016 23.0487L42.2155 23.0487C 42.2247 23.0487 42.2293 23.0533 42.234 23.0533L42.234 23.0533L42.8858 23.2336L43.6025 23.437L43.866 23.511L43.866 20.5706C 43.866 19.1512 45.0033 18 46.4088 18C 47.1116 18 47.7496 18.2866 48.2073 18.7536C 48.665 19.2206 48.9517 19.8586 48.9517 20.5706L48.9517 20.5706L48.9517 24.935L49.4787 25.0829C 49.5203 25.0968 49.5619 25.1153 49.5989 25.143C 49.7284 25.2401 49.9133 25.3835 50.1491 25.5591C 50.334 25.7071 50.5328 25.8874 50.7733 26.0723C 51.2495 26.4561 51.8181 26.9508 52.4423 27.5194C 52.6087 27.6628 52.7705 27.8107 52.9185 27.9587C 53.7229 28.7076 54.6245 29.5861 55.4844 30.557C 55.7248 30.8297 55.9606 31.1071 56.201 31.3984C 56.4415 31.6943 56.6957 31.9856 56.9177 32.2769C 57.2089 32.6652 57.5233 33.0674 57.7961 33.4882C 57.9255 33.687 58.0735 33.8904 58.1983 34.0892C 58.5497 34.6209 58.8595 35.1711 59.1554 35.7212C 59.2802 35.9755 59.4096 36.2529 59.5206 36.5257C 59.8488 37.2608 60.1078 38.0098 60.2742 38.7588C 60.3251 38.9206 60.362 39.0963 60.3805 39.2535L60.3805 39.2535L60.3805 39.2904C 60.436 39.5124 60.4545 39.7482 60.473 39.9886C 60.547 40.756 60.51 41.5235 60.3435 42.2956C 60.2742 42.6239 60.1817 42.9336 60.0708 43.2619C 59.9598 43.5763 59.8488 43.9045 59.7055 44.2143C 59.4281 44.8569 59.0999 45.4996 58.7115 46.1006C 58.5867 46.3225 58.4387 46.5583 58.2908 46.7802C 58.129 47.016 57.9625 47.238 57.8146 47.4553C 57.6112 47.7327 57.3939 48.0239 57.1719 48.2828C 56.9731 48.5556 56.7697 48.8284 56.5478 49.0688C 56.238 49.434 55.9421 49.7808 55.6324 50.1137C 55.4474 50.331 55.2486 50.5529 55.0452 50.7517C 54.8464 50.9736 54.643 51.1724 54.458 51.3573C 54.1483 51.6671 53.8894 51.9075 53.6721 52.1063L53.6721 52.1063L53.1635 52.5733C 53.0895 52.638 52.9924 52.675 52.8907 52.675L52.8907 52.675L48.9517 52.675L48.9517 57.7283L53.9079 57.7283C 55.0175 57.7283 56.0716 57.3353 56.9223 56.6141C 57.2135 56.3598 58.485 55.2594 59.9876 53.5997C 60.0384 53.5442 60.1031 53.5026 60.1771 53.4841L60.1771 53.4841L73.8668 49.5265C 74.1211 49.4525 74.38 49.6467 74.38 49.9149z" stroke="none" fill="#2081E2" fillRule="nonzero"></path>
                    </svg> OpenSea
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {loading && <div className="text-center"><div className="spinner-border" style={{width: '5rem', height: '5rem',}}></div></div>}
    </section>
  );
}

export default Sale;
